import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import helpExame from "./store/HelpExameStore";
import notificacao from "./features/mensagemAlerta/redux/mensagemAlertaReducer";
import login from "./features/login/Store";
import cabecalhoPagina from "./features/cabecalho/Store";
import empresa from "./themes/Manager/Store";

const reducers = combineReducers({
  login,
  helpExame,
  notificacao,
  cabecalhoPagina,
  empresa
});

const composeEnhancers =
  (process.env.NODE_ENV === "development"
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null) || compose;

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

export type RootState = ReturnType<typeof reducers>;

export default store;
